import * as z from 'zod';

export const MAX_CODE_LENGTH = 6;
export const PASSWORD_MIN_LENGTH = 8;

export const BasicPasswordSchema = z.string().min(PASSWORD_MIN_LENGTH);

export const FullPasswordSchema = z
	.string()
	.min(8)
	.regex(/[A-Z]+/)
	.regex(/[a-z]+/)
	.regex(/[0-9]+/);

export const CodeSchema = z.string().min(MAX_CODE_LENGTH).max(MAX_CODE_LENGTH);

export const EmailSchema = z.string().email();
